import { useQuery } from "react-query";
import {
  apiListCandidateContracts,
  IApiListCandidateContractsParams,
} from "../../../../../api/contract/apiListCandidateContracts";
import {
  ExtractFnReturnType,
  QueryConfig,
} from "../../../../../lib/react-query";
import { contractKeys } from "../util/contract.query-keys";

type QueryFnType = typeof apiListCandidateContracts;

type TUseCandidateContractsOptions = {
  params: IApiListCandidateContractsParams;
  config?: QueryConfig<QueryFnType>;
};

export const useCandidateContracts = ({
  params,
  config,
}: TUseCandidateContractsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: contractKeys.listForCandidate(params),
    queryFn: () => apiListCandidateContracts(params),
  });
};
